export enum CHART_UNIT {
  KWH = 'KWH',
  EUR = 'EUR',
  NOVALUE = ''
}
